import { toast } from 'react-toastify';
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryKeys } from '../react-query/constant';
import { api, config, getUserSettingRequest } from '../helpers/api';

const useGetOrganizationFeatures = () => {
  const request = async () => {
    const response = await api.get('/organization_features/', config('json'));
    return response.data;
  };
  return useQuery([queryKeys.organization_features], request);
};

const useGetUserSetting = () => {
  return useQuery([queryKeys.user_setting], getUserSettingRequest, {
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });
};

const useUpdateUserSetting = () => {
  const request = async ({ data }) => {
    return await api.patch('/user_setting/', { ...data }, config('json'));
  };
  return useMutation(request, {
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });
};

export { useGetOrganizationFeatures, useGetUserSetting, useUpdateUserSetting };
